// /x/$slug — public single-artifact media share page. Mirrors the
// share-visualization route wiring (public, no guard; ClientLayout renders
// `/x/` chromeless). Backed by GET /api/shared-artifacts/:slug.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const SharedArtifactPage = lazy(() => import('@/app/x/[slug]/page'));

export const shareArtifactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/x/$slug',
  component: SharedArtifactPage,
});
